import React, { useState, useEffect } from 'react';
import type { FieldProps } from '../types';

/**
 * TextAreaField Component
 *
 * Renders multi-line text input.
 */
export const TextAreaField: React.FC<FieldProps> = ({
  element,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  theme,
}) => {
  const properties = element.properties;
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <div className="mediform-field mediform-textarea-field">
      {properties?.label && (
        <label htmlFor={element.id} className="mediform-field-label">
          {properties.label}
          {properties.required && <span className="mediform-required"> *</span>}
        </label>
      )}

      <div className="mediform-field-input">
        <textarea
          id={element.id}
          value={localValue}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          required={properties?.required}
          minLength={properties?.minLength}
          maxLength={properties?.maxLength}
          placeholder={properties?.label}
          rows={4}
          className={`mediform-textarea ${error ? 'mediform-input-error' : ''}`}
          style={{
            borderColor: error ? theme?.colors?.error : theme?.colors?.border,
          }}
        />
      </div>

      {error && (
        <div className="mediform-field-error" style={{ color: theme?.colors?.error }}>
          {error}
        </div>
      )}

      {properties?.maxLength && (
        <div className="mediform-field-hint">
          {localValue.length} / {properties.maxLength} characters
        </div>
      )}
    </div>
  );
};

export default TextAreaField;
